import delivery from '@/services/delivery';

// TODO: write tests
async function getDeliveryEstimate({ rootGetters }, timestamp) {
  try {
    const order = rootGetters['orders/order'];

    const location = rootGetters['locations/selectedLocation'];

    const merchant = rootGetters['merchant/merchant'];

    const orderDetails = rootGetters['session/orderDetails'];

    const address = orderDetails.deliveryAddress;

    const addressGeocodeData = orderDetails.deliveryAddressGeoCoordinates;

    const menuType = orderDetails.orderType === 'catering' ? 'Catering' : 'Delivery';

    const getEstimatePayload = {
      menuType,
      address,
      addressGeocodeData,
      deliveryTime: timestamp,
      location,
      merchant,
      order
    };

    const estimateResult = await delivery.getEstimate(getEstimatePayload);

    return estimateResult;
  }

  catch (error) {
    throw error;
  }
}

export { getDeliveryEstimate };
